import { render, staticRenderFns } from "./SpecialNote.vue?vue&type=template&id=2983f98b&scoped=true&"
import script from "./SpecialNote.vue?vue&type=script&lang=js&"
export * from "./SpecialNote.vue?vue&type=script&lang=js&"
import style0 from "./SpecialNote.vue?vue&type=style&index=0&id=2983f98b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2983f98b",
  null
  
)

export default component.exports